import { Button } from '#atoms';
import { PATH } from '#const/path';
import { FloatButtonContainer } from '#molecules';
import { onBoardStateAtom } from '#pages/OnBoardStep/OnBoardStep.atoms';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import DefaultFeature from './DefaultFeature';
import NewFeature from './NewFeature';

export function OnBoardComplete() {
  const navigate = useNavigate();

  const onBoardState = useRecoilValue(onBoardStateAtom);

  const handleStart = () => {
    // if (profileUrl) {
    //   navigate(PATH.ONBOARD_PARTNERS);
    // } else {
    //   navigate(PATH.HOME);
    // }
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding_fibudstart_click',
        category: '신규가입 온보딩',
        action: 'onboarding_fibudstart_click',
        value: 2
      }
    });
    navigate(PATH.ONBOARD_PARTNERS);
  };

  return (
    <>
      <Wrapper>
        <CheckImg src="/images/tick.png" />
        <Title>이제 모든 준비가{'\n'}완료되었어요!</Title>
        {/* <Description>
          피벗에 오신 것을 환영합니다{'\n'}
          회원 관리를 시작해 볼까요?
        </Description> */}
        {onBoardState.feature === '기본기능' && <DefaultFeature />}
        {onBoardState.feature === '신규회원창출기능' && <NewFeature />}
      </Wrapper>
      <FloatButtonContainer>
        <Button onClick={handleStart}>피벗 시작하기</Button>
      </FloatButtonContainer>
    </>
  );
}

const Wrapper = styled.section`
  padding: 100px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CheckImg = styled.img`
  width: 74px;
  height: 53px;
`;

const Title = styled.span`
  margin-top: 52px;
  white-space: pre-wrap;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  text-align: center;
`;
